import React from 'react'
import './SomaTitlePage.css'

const SomaTitlePage = props =>(<h1 id='title' className="h1__title--pages"> {props.children} </h1>)


export default SomaTitlePage